<template>
  <div class="policy container">
    <div class="ql-editor my-64 p-24 bg-white border border-grey-lighter rounded shadow" style="min-height: 50vh;" v-loading="isLoading" v-html="this.content"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: 'Policy',
  metaInfo () {
    return {
      title: 'Policy'
    }
  },
  data () {
    return {
      content: null,
      isLoading: false
    }
  },
  methods: {
    fetchContent: function (type) {
      this.isLoading = true
      return request({
        url: `policies/${type}`
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  computed: {
    ...mapState([
      'route'
    ])
  },
  created () {
    this.fetchContent(this.$route.name).then(res => {
      this.content = res.data.content
    })
  },
  watch: {
    route: function (newVal, oldVal) {
      this.fetchContent(newVal.name).then(res => {
        this.content = res.data.content
      })
    }
  }
}
</script>

<style lang="sass">
</style>
